module.exports = __webpack_public_path__ + "img/project-inspections-remaining.ac966c77.svg";